module.exports = __webpack_public_path__ + "img/my-coin.59a7c1cc.png";